(() => {
  const modules = (window.Menotest ||= {}).modules ||= {};
  if (modules.ruta) {
    modules.ruta.initAll(document);
    return;
  }

  const selector = '[data-menotest-section="ruta"]';
  const cleanups = new WeakMap();
  const reduceMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const clamp = (value, min = 0, max = 1) => Math.min(max, Math.max(min, value));
  const listen = (target, event, handler, options, cleanup) => {
    target.addEventListener(event, handler, options);
    cleanup.push(() => target.removeEventListener(event, handler, options));
  };

const initJourney = (root, cleanup) => {
    const journey = root.querySelector('[data-journey]');
    if (!journey) return;
    const steps = [...journey.querySelectorAll('[data-journey-step]')];
    const panel = journey.querySelector('[role="tabpanel"]');
    const progress = journey.querySelector('[data-journey-progress]');
    const statusSeparator = journey.dataset.statusSeparator || ' / ';
    const contents = steps.map((step) => ({
      label: step.dataset.panelLabel,
      title: step.dataset.panelTitle,
      body: step.dataset.panelBody,
      visual: step.querySelector('[data-journey-template]')?.innerHTML || ''
    }));
    if (!steps.length || !panel) return;
    const setText = (node, value) => {
      if (!node) return;
      const parts = String(value || '').split('Tu Mejor Etapa™');
      node.replaceChildren(...parts.flatMap((part, index) => {
        const nodes = [document.createTextNode(part)];
        if (index < parts.length - 1) {
          const strong = document.createElement('strong');
          strong.className = 'menotest-trademark';
          strong.textContent = 'Tu Mejor Etapa™';
          nodes.push(strong);
        }
        return nodes;
      }));
    };
    const setActive = (index) => {
      const current = contents[index];
      steps.forEach((step, stepIndex) => {
        const selected = stepIndex === index;
        step.classList.toggle('is-active', selected);
        step.setAttribute('aria-selected', String(selected));
        step.tabIndex = selected ? 0 : -1;
      });
      const stepLabel = panel.querySelector('[data-journey-panel-step]');
      const label = panel.querySelector('[data-journey-panel-label]');
      const title = panel.querySelector('[data-journey-panel-title]');
      const body = panel.querySelector('[data-journey-panel-body]');
      const visual = panel.querySelector('[data-journey-panel-visual]');
      if (stepLabel) stepLabel.textContent = `${String(index + 1).padStart(2, '0')}${statusSeparator}${String(steps.length).padStart(2, '0')}`;
      setText(label, current.label);
      setText(title, current.title);
      setText(body, current.body);
      if (visual && current.visual) visual.innerHTML = current.visual;
      if (panel) panel.setAttribute('aria-labelledby', steps[index].id);
      if (progress) progress.style.width = `${((index + 1) / steps.length) * 100}%`;
    };
    steps.forEach((step, index) => {
      listen(step, 'click', () => setActive(index), undefined, cleanup);
      listen(step, 'keydown', (event) => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        const next = (index + (event.key === 'ArrowRight' ? 1 : -1) + steps.length) % steps.length;
        steps[next].focus();
        setActive(next);
      }, undefined, cleanup);
    });
    setActive(0);
  };

  const init = (root) => {
    if (!root || cleanups.has(root)) return;
    const cleanup = [];
    root.classList.add('menotest-js-ready');
    initJourney(root, cleanup);
    cleanups.set(root, cleanup);
  };
  const destroy = (root) => {
    (cleanups.get(root) || []).forEach((callback) => callback());
    cleanups.delete(root);
    root.classList.remove('menotest-js-ready');
  };
  const initAll = (container = document) => {
    if (container.matches?.(selector)) init(container);
    container.querySelectorAll?.(selector).forEach(init);
  };
  modules.ruta = { initAll, destroy };
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    if (event.target.matches?.(selector)) destroy(event.target);
    event.target.querySelectorAll?.(selector).forEach(destroy);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  else initAll();
})();
